import { gql } from "@apollo/client";

export const FEETCH_EXTERNAL_ORDERS = gql`
  query FEETCH_EXTERNAL_ORDERS($source: String!) {
    externalOrders(source: $source) {
      sourceOrderId
      orderNumber
      orderDate
      status
      requestedShipDate
      requestedDeliveryDate
      paymentTerms
      shippingMethod
      total
      contact {
        name
        email
        phone
        externalId
      }
      shipTo {
        name
        line1
        line2
        city
        state
        postalCode
        country
        externalId
      }
      billTo {
        name
        line1
        line2
        city
        state
        postalCode
        country
        externalId
      }
      lines {
        lineNumber
        productExternalId
        buyerSku
        vendorSku
        upc
        description
        quantity
        uom
        unitPrice
        listPrice
        lineTotal
      }
    }
  }
`;

export const FETCH_INC_ODOO_PRODUCTS = gql`
  query FETCH_INC_ODOO_PRODUCTS {
    odooProducts(
      instance: "INC"
      fields: ["default_code", "x_studio_markettime_product_id"]
    )
  }
`;

export const FETCH_INC_EXTERNAL_ORDER_CUSTOMERS = gql`
  query FETCH_INC_EXTERNAL_ORDER_CUSTOMERS($useType: String!) {
    odooCustomers(instance: "INC", useType: $useType)
  }
`;

export const CREATE_ODOO_SALES_ORDERS = gql`
  mutation CREATE_ODOO_SALES_ORDERS(
    $source: String!
    $orders: [CreateOdooSalesOrderInput]!
  ) {
    salesCreateOdooSalesOrders(source: $source, orders: $orders) {
      result
    }
  }
`;

export const FETCH_ODOO_EXTERNAL_SALES_ORDERS = gql`
  query FETCH_ODOO_EXTERNAL_SALES_ORDERS(
    $sourceType: String!
    $sourceIds: [String]
  ) {
    odooSaleOrders(
      instance: "INC"
      sourceType: $sourceType
      sourceIds: $sourceIds
    )
  }
`;
